import { RootState } from "redux-store";

export const getMerchant = (state: RootState) => state?.merchant;
export const getIsCreateMerchantDialogOpen = (state: RootState) =>
  state?.merchant?.isCreateMerchantDialogOpen;
export const getMerchantsList = (state: RootState) =>
  state?.merchant?.list ?? [];
export const getMerchantUsages = (state: RootState) =>
  state?.merchant?.usages ?? [];
export const getIsCreateMerchantBannerDialogOpen = (state: RootState) =>
  state?.merchant?.isCreateMerchantBannerDialogOpen;
export const getIsCreateDefaultEventDialogOpen = (state: RootState) =>
  state?.merchant?.isCreateDefaultEventDialogOpen;
